import React from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import './App.css';
import Header from './components/Header/Header';
import Hero from './components/Hero/Hero';
import GlobalApproach from './components/GlobalApproach/GlobalApproach';
import ServicesWhite from './components/Services/ServicesWhite';
import ScrollingBanner from './components/ScrollingBanner/ScrollingBanner';
import SynergyDiagram from './components/SynergyDiagram/SynergyDiagram';
import CohortCountdown from './components/CohortCountdown/CohortCountdown';
import Testimonials from './components/Testimonials/Testimonials';
import IntegrationStats from './components/IntegrationStats/IntegrationStats';
import Webinar from './components/Webinar/Webinar';
import DiagnosticBanner from './components/DiagnosticBanner/DiagnosticBanner';
import Dashboard from './components/Dashboard/Dashboard';
import Newsletter from './components/Newsletter/Newsletter';
import GuideDownload from './components/GuideDownload/GuideDownload';
import CommercialCTA from './components/CommercialCTA/CommercialCTA';
import Footer from './components/Footer/Footer';
import Methode from './components/Methode/Methode';
import Score from './components/Score/Score';
import CaseStudy from './components/CaseStudy/CaseStudy';
import FAQ from './components/FAQ/FAQ';
import About from './components/About/About';
import Charter from './components/Charter/Charter';
import Suite from './components/Suite/Suite';
import ScrollToTop from './components/ScrollToTop';
import {
  ConseilFormation,
  Recrutement,
  ServicesFinanciers,
  Agences,
  ESN,
  EditeursLogiciels,
  SolutionsPro,
  Technologie,
  Videosurveillance,
  Industrie,
  Equipement,
  BTP,
  EnergiesRenouvelables,
  Logistique,
  Hotellerie,
  Evenementiel,
  Nettoyage,
  Transport,
  RSE
} from './components/Sectors';

function Home() {
  return (
    <>
      <Hero />
      <GlobalApproach />
      <ServicesWhite />
      <ScrollingBanner />
      <SynergyDiagram />
      <CohortCountdown />
      <Testimonials />
      <IntegrationStats />
      <Webinar />
      <DiagnosticBanner />
      <Dashboard />
      <Newsletter />
      <GuideDownload />
      <CommercialCTA />
    </>
  );
}

function App() {
  return (
    <Router>
      <ScrollToTop />
      <div className="App">
        <Header />
        <Routes>
          <Route path="/" element={<Home />} />
          <Route path="/methode" element={<Methode />} />
          <Route path="/score" element={<Score />} />
          <Route path="/etudes-de-cas" element={<CaseStudy />} />
          <Route path="/faq" element={<FAQ />} />
          <Route path="/a-propos" element={<About />} />
          <Route path="/charte" element={<Charter />} />
          <Route path="/suite" element={<Suite />} />
          
          {/* Routes pour les secteurs */}
          <Route path="/secteurs/conseil-formation" element={<ConseilFormation />} />
          <Route path="/secteurs/recrutement" element={<Recrutement />} />
          <Route path="/secteurs/services-financiers" element={<ServicesFinanciers />} />
          <Route path="/secteurs/agences" element={<Agences />} />
          <Route path="/secteurs/esn" element={<ESN />} />
          <Route path="/secteurs/editeurs-logiciels" element={<EditeursLogiciels />} />
          <Route path="/secteurs/solutions-pro" element={<SolutionsPro />} />
          <Route path="/secteurs/technologie" element={<Technologie />} />
          <Route path="/secteurs/videosurveillance" element={<Videosurveillance />} />
          <Route path="/secteurs/industrie" element={<Industrie />} />
          <Route path="/secteurs/equipement" element={<Equipement />} />
          <Route path="/secteurs/btp" element={<BTP />} />
          <Route path="/secteurs/energies-renouvelables" element={<EnergiesRenouvelables />} />
          <Route path="/secteurs/logistique" element={<Logistique />} />
          <Route path="/secteurs/hotellerie" element={<Hotellerie />} />
          <Route path="/secteurs/evenementiel" element={<Evenementiel />} />
          <Route path="/secteurs/nettoyage" element={<Nettoyage />} />
          <Route path="/secteurs/transport" element={<Transport />} />
          <Route path="/secteurs/rse" element={<RSE />} />
        </Routes>
        <Footer />
      </div>
    </Router>
  );
}

export default App;
